import { useParams } from 'react-router-dom';

// import CustomerForm from "./components/CustomerForm";
import TermsAndConditionsPage from "./components/TermsConditions";
import termsData from './terms-data.json';
import { useEffect, useState } from 'react';
import SwitchButton from '../../components/Switch';
import JotForm from '../../components/JotForm';

import "./index.css";
import Privacy from './components/Privacy';
import Video from './components/Video';

export default function Register() {
    const { type } = useParams();

    const [tabIndex, setTabIndex] = useState<string>('customer');
    const [activeIndex, setActiveIndex] = useState('Customer Form');

    useEffect(() => {
        if (type)
            setTabIndex(type);
    }, [type])

    useEffect(() => {
        if (activeIndex === 'Terms & Condition') {
            setTabIndex('terms')
        }
        if (activeIndex === 'Privacy Policy') {
            setTabIndex('privacy')
        }
        if (activeIndex === 'Customer Form') {
            setTabIndex('customer')
        }
        // if (activeIndex === 'Video Explanation') {
        //     setTabIndex('video')
        // }
        if (activeIndex === 'Support') {
            window.open('https://www.facebook.com/profile.php?id=61573878153297', '_blank');
            setActiveIndex(prevIndex => {
                if (prevIndex === 'Support') return 'Customer Form';
                return prevIndex;
            });
        }
    }, [activeIndex])

    // const desktopLabels = ['Terms & Condition', 'Privacy Policy', 'Customer Form', 'Video Explanation', 'Support'];
    const desktopLabels = ['Terms & Condition', 'Privacy Policy', 'Customer Form', 'Support'];

    return (
        <div className="flex items-center justify-center pt-[159px] md:pt-[260px] px-2">
            <div className="max-w-[1396px] px-2 w-full rounded-[40px] py-[9px] md:py-[30px] md:px-[40px]  flex flex-col items-center mb-[40px]">
                <div className="max-w-[1154px] w-full " >
                    <SwitchButton  active={activeIndex} setActive={setActiveIndex} labels={desktopLabels} />
                </div>
                <div className='overflow-wrap-anywhere w-full'>
                    {tabIndex === 'customer' && <JotForm className="mt-4" />}
                    {tabIndex === 'terms' && <TermsAndConditionsPage data={termsData} />}
                    {tabIndex === 'privacy' && <Privacy />}
                    {/* {tabIndex === 'video' && <Video />} */}
                </div>
            </div>
        </div>
    )
}